<span *ngIf="selected && direction == 1" class="fa fa-sort-asc"></span>
<span *ngIf="selected && direction == 2" class="fa fa-sort-desc"></span>
<span *ngIf="(selected && direction == 0) || (!selected)" class="fa fa-sort"></span>
